import { PlayerCapsule } from "./PlayerCapsule";

import { GameVars } from "../../GameVars";

import { GameConstants } from "../../GameConstants";

import { Piece } from "../Piece";

import { Board } from "../Board";

export class HUD extends Phaser.Group {

    private initialTurnMessage: Phaser.Text;
    private timerLabel: Phaser.Text;
    private movesLabel: Phaser.Text;
    private playerCapsule: PlayerCapsule;
    private adversaryCapsule: PlayerCapsule;
    private fpsLabel: Phaser.Text;

    constructor(game: Phaser.Game) {

        super(game, null, "hud");

        this.timerLabel = new Phaser.Text(this.game, 260, 10, GameVars.formatTime(GameVars.time), { font: "60px Roboto Slab Light", fill: GameConstants.TEXT_COLOR_BLACK, align: "center"}); 
        this.timerLabel.visible = GameVars.isTimerOn;
        this.timerLabel.alpha = 0;
        this.timerLabel.scale.y = GameVars.scaleY;
        this.add(this.timerLabel);

        let movesString = GameVars.getMoves() === 1 ? " MOVE" : " MOVES";

        this.movesLabel = new Phaser.Text(this.game, 740, 50, GameVars.getMoves().toString() + movesString, { font: "35px Roboto Slab Light", fill: GameConstants.TEXT_COLOR_BLACK, align: "center"}); 
        this.movesLabel.anchor.set(1, .5);
        this.movesLabel.scale.y = GameVars.scaleY;
        this.add(this.movesLabel);

        if (GameConstants.DEVELOPMENT) {
            this.fpsLabel = new Phaser.Text(this.game, 740, 5, "fps:" + this.game.time.fps, { font: "17px Roboto Slab Light", fill: GameConstants.TEXT_COLOR_BLACK, align: "center"}); 
            this.fpsLabel.anchor.x = 1;
            this.fpsLabel.scale.y = GameVars.scaleY;
            this.add(this.fpsLabel);
        }
    }

    public update(): void {

        super.update();

        if (!GameVars.gameFinished && GameVars.isTimerOn) {
            this.timerLabel.text = GameVars.formatTime(GameVars.time);
            this.timerLabel.alpha = 1;
        }
        
        if (GameConstants.DEVELOPMENT) {
                this.fpsLabel.text = "fps:" + this.game.time.fps;
        }
    }

    public timerVisibilityStatusChanged(): void {
        
        this.timerLabel.visible = GameVars.isTimerOn;

        if (this.timerLabel.visible) {
            this.timerLabel.alpha = 1;
        } else {
            this.timerLabel.alpha = 0;  
        }
    }

    public startGame(): void {

        // se crean los contenedores de piezas capturadas
        this.adversaryCapsule = new PlayerCapsule(this.game, false);
        this.addAt(this.adversaryCapsule, 0);
    
        this.playerCapsule = new PlayerCapsule(this.game, true);
        this.addAt(this.playerCapsule, 0);
    
        if (!GameVars.gameFinished) {
            this.showInitialMessage();
        }
    }

    public accountMovement(): void {

        let movesString = GameVars.getMoves() === 1 ? " MOVE" : " MOVES";
        this.movesLabel.text = GameVars.getMoves().toString() + movesString;

        if (GameVars.getCurrentTurn() !== GameVars.colorPlayer) {
                this.adversaryCapsule.startPulsing();
                this.playerCapsule.stopPulsing();
        } else {
            this.adversaryCapsule.stopPulsing();
            this.playerCapsule.startPulsing();
        }
    }

    public endGame (): void {
        
        this.adversaryCapsule.stopPulsing();

        this.timerLabel.visible = false;
        this.movesLabel.visible = false;
    }

    public pieceCaptured(capturedPiece: Piece): void {

        if (this.playerCapsule.color !== GameVars.currentTurn) {
            this.playerCapsule.capturedPieces.addCapturedPiece(capturedPiece);
        } else {
            this.adversaryCapsule.capturedPieces.addCapturedPiece(capturedPiece);
        }
    }

    public revertCapturedPiece(): void {
        
        if (this.playerCapsule.color === GameVars.currentTurn) {
            this.playerCapsule.capturedPieces.configurePieceIcons();
        } else {
            this.adversaryCapsule.capturedPieces.configurePieceIcons();
        }
    }

    private showInitialMessage(): void {

        let textColor: string;
        let messageText: string;
        let stroke: string;

        // dependiendo de quien es el turno mostrar inicialmente un mensaje u otro
        if (GameVars.currentTurn !== GameVars.colorPlayer) {

            messageText = "RIVAL'S TURN";
            textColor = GameVars.colorPlayer === GameConstants.WHITE ? "#1B2D3D" : "#F6F9EF";
            stroke = GameVars.colorPlayer === GameConstants.WHITE ? "#F6F9EF" : "#1B2D3D";

            this.adversaryCapsule.startPulsing();

        } else {

            messageText = "YOUR TURN";
            textColor = GameVars.colorPlayer === GameConstants.WHITE ? "#F6F9EF" : "#1B2D3D";
            stroke = GameVars.colorPlayer === GameConstants.WHITE ? "#1B2D3D" : "#F6F9EF";

            this.playerCapsule.startPulsing();
        }

        this.initialTurnMessage = new Phaser.Text(this.game, GameConstants.GAME_WIDTH / 2, Board.BOARD_PY - 100 * GameVars.scaleY, messageText, 
        { font: "64px Roboto Slab Bold", fill: textColor, align: "center"});
        
        this.initialTurnMessage.stroke = stroke;
        this.initialTurnMessage.strokeThickness = 10;

        this.initialTurnMessage.scale.y = GameVars.scaleY;
        this.initialTurnMessage.anchor.set(.5);
        this.add(this.initialTurnMessage);

        this.initialTurnMessage.alpha = 0;

        this.game.add.tween(this.initialTurnMessage)
            .to ({alpha: 1}, 350, Phaser.Easing.Cubic.Out, true);

        this.game.add.tween(this.initialTurnMessage)
            .to ({alpha: 0}, 450, Phaser.Easing.Cubic.Out, true, 1500)
            .onComplete.add(function(): void {
                this.initialTurnMessage.destroy();
            }, this);
    }
}
